import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { CookiesProvider } from 'react-cookie';
import AuthProvider from './providers/AuthProvider';
import Router from './navigation/Router';
import InitialDataProvider from './providers/InitialDataProvider';
import HelpersProvider from './providers/HelpersProvider';
import AntConfigProvider from './providers/AntConfigProvider';
import ScreenTypeProvider from './providers/ScreenTypeProvider';
import ThemeProvider from './providers/ThemeProvider';
import MetaInfo from './components/meta/MetaInfo';
import RNWebViewProvider from './providers/RNWebViewProvider';
import SmartAppBanner from './components/banner/SmartAppBanner';
import RNNotificationProvider from './providers/RNNotificationProvider';
import AppStateProvider from './providers/AppStateProvider';
import BusinessProfileProvider from './providers/BusinessProfileProvider';
import OCCAgentGate from './navigation/middleware/OCCAgentGate';
import IntercomWidget from './widgets/IntercomWidget';
import BrandProvider from './providers/BrandProvider';
import { loadGoogleMaps } from './services/helpers/GoogleMapsLoader';

export default function App() {
  useEffect(() => {
    loadGoogleMaps().catch(() => {});
  }, []);

  return (
    <CookiesProvider>
      <AuthProvider>
        <BrandProvider>
          <OCCAgentGate>
            <ThemeProvider>
              <AntConfigProvider>
                <ScreenTypeProvider>
                  <MetaInfo />
                  <SmartAppBanner />
                  <RNWebViewProvider>
                    <InitialDataProvider>
                      <AppStateProvider>
                        <RNNotificationProvider>
                          <HelpersProvider>
                            <BusinessProfileProvider>
                              <Router />
                              <ToastContainer
                                position="top-right"
                                autoClose={3000}
                                hideProgressBar
                                newestOnTop
                                pauseOnHover={false}
                                className="px-1 z-[999999]"
                                toastClassName="my-2 rounded-lg"
                              />
                              <IntercomWidget />
                            </BusinessProfileProvider>
                          </HelpersProvider>
                        </RNNotificationProvider>
                      </AppStateProvider>
                    </InitialDataProvider>
                  </RNWebViewProvider>
                </ScreenTypeProvider>
              </AntConfigProvider>
            </ThemeProvider>
          </OCCAgentGate>
        </BrandProvider>
      </AuthProvider>
    </CookiesProvider>
  );
}
